import DecoratedLink from '@js/DecoratedLink'

/**
 * Searches for target="_blank" links and adds screen-reader text and an icon.
 *
 * @extends DecoratedLink
 */
class ExternalLink extends DecoratedLink {
    constructor(element) {
        super(element, {
            iconName: 'fa-arrow-up-right-from-square',
            iconStyle: 'fa-solid',
            classSuffix: 'external',
            srMessage: 'opens in a new tab'
        })

        if (sir.isEditor) return

        const externalRel = ['noreferrer', 'noopener']
        externalRel.forEach(value => {
            if (![...element.relList].includes(value)) {
                element.rel = `${element.rel} ${value}`
            }
        })
    }
}

ExternalLink.create('a[target=_blank]')
